// libs
import moment from 'moment'
// types
import { RightSectionRow } from 'components/Modals/MatrixModal/components/Matrix/types'
import { FieldType, IField } from 'types/graphql'
// constants
import { DATE_FORMAT_VALUES } from 'constants/objects'
// utils
import { find, flatten, pipe } from 'lodash/fp'
import { getMatrixSerializedValue } from 'utils/form/matrix'

export const getFieldValue = (value: any, field: IField) => {
  if (field.fieldType === FieldType.Switch) {
    return value.toString()
  }

  if (field.fieldType === FieldType.RiskMatrix) {
    const row = pipe(
      flatten,
      find<RightSectionRow>(({ id }) => id === (value?.value || value)),
      (cell) =>
        field.settings.options.find(({ id }) =>
          typeof cell?.value === 'string' ? id === cell?.value : id === cell?.value.id
        )
    )(field.settings.bRightSection)

    if (field.exportHeaders) {
      const { label: matrixValue, likelihood, consequence } = getMatrixSerializedValue(value?.value, field, value)

      return {
        label: `${matrixValue} - ${consequence} x ${likelihood}`,
        color: row?.color
      }
    }

    return row
  }

  if (field.fieldType === FieldType.Date) {
    if (field.settings.format === DATE_FORMAT_VALUES.TIME) {
      return moment(value).format('HH:mm')
    }

    if (field.settings.format === DATE_FORMAT_VALUES.DATE_TIME) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    }

    return moment(value).format('DD/MM/YYYY')
  }

  if (field.fieldType === FieldType.Tag) {
    return value?.map((item) => item.title).join(', ')
  }

  if (field.fieldType === FieldType.Address) {
    return value?.value?.address
  }

  if (field.fieldType === FieldType.Lookup) {
    if (Array.isArray(value)) {
      return value.map((item) => field.options.find((option) => option.value === item.value)?.label).join(', ')
    }
    return field.options.find((option) => option.value === value?.value)?.label
  }

  if (field.fieldType === FieldType.PickList) {
    if (field.responseTypeId) {
      return field.options.find((option) => option.id === value?.value)
    }

    if (Array.isArray(value)) {
      return value.map((item) => field.options.find((option) => option.id === item.value)?.label).join(', ')
    }

    return field.options.find((option) => option.id === value?.value)?.label
  }

  return value
}
